var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { sendToAnalytics } from './mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
var NfGoogleTracking = /** @class */ (function (_super) {
    __extends(NfGoogleTracking, _super);
    function NfGoogleTracking() {
        var _this = _super.call(this) || this;
        _this.formDetails = {
            2: {
                category: 'Form',
                action: 'Submit',
                label: 'Contact us form',
            },
            7: {
                category: 'Form',
                action: 'Submit',
                label: 'Plan form enquiry'
            },
        };
        _this.addMarionetteListeners();
        return _this;
    }
    NfGoogleTracking.prototype.addMarionetteListeners = function () {
        var parent = this;
        if (!window.Marionette) {
            return;
        }
        new (window.Marionette.Object.extend({
            initialize: function () {
                this.listenTo(window.Backbone.Radio.channel('forms'), 'submit:response', this.actionSubmit);
            },
            actionSubmit: function (response) {
                parent.ninjaFormSubmit(response.data);
            },
        }))();
    };
    NfGoogleTracking.prototype.ninjaFormSubmit = function (form) {
        if (!this.formDetails[form.form_id])
            return;
        // Only track analytics from "sales type" form requests
        if (!Object.keys(this.formDetails).includes(form.form_id)) {
            return;
        }
        this.sendToAnalytics(__assign({ type: 'event' }, this.formDetails[form.form_id]));
    };
    NfGoogleTracking.prototype.parseID = function (elementID) {
        var matches = elementID.match(/nf-form-([0-9]+)-cont/);
        if (matches) {
            return parseInt(matches[1]);
        }
        return -1;
    };
    NfGoogleTracking = __decorate([
        Component
    ], NfGoogleTracking);
    return NfGoogleTracking;
}(mixins(sendToAnalytics)));
export { NfGoogleTracking };
